// ABOUTME: Banner prompting users to install the PWA
// ABOUTME: Shows after 2nd visit, respects dismissal

import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { usePWAInstall } from '@/hooks/usePWAInstall'

export default function InstallPrompt() {
  const { shouldShowPrompt, promptInstall, dismissPrompt } = usePWAInstall()

  if (!shouldShowPrompt) {
    return null
  }

  const handleInstall = async () => {
    await promptInstall()
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-40 animate-in slide-in-from-bottom duration-300">
      <div className="bg-surface rounded-lg shadow-lg border border-fg-tertiary/20 p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center">
            <ArrowDownTrayIcon className="w-5 h-5 text-primary-600 dark:text-primary-400" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-fg-primary text-sm">Install Gentlemen App</h3>
            <p className="text-xs text-fg-secondary mt-0.5">
              Add to your home screen for quick access
            </p>
          </div>
          <button
            type="button"
            onClick={dismissPrompt}
            className="flex-shrink-0 p-1 text-fg-tertiary hover:text-fg-primary"
            aria-label="Dismiss"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-3 flex gap-2">
          <button
            type="button"
            onClick={handleInstall}
            className="flex-1 bg-primary-600 hover:bg-primary-700 text-white text-sm py-2 px-4 rounded-lg font-medium transition-colors"
          >
            Install
          </button>
          <button
            type="button"
            onClick={dismissPrompt}
            className="text-fg-secondary hover:text-fg-primary text-sm py-2 px-4 rounded-lg font-medium transition-colors"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  )
}
